"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TYPOS = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _consts = require("./../consts.js");

var __jsx = _react.default.createElement;
var TYPOS = {
  "h1w": {
    size: 45,
    height: 50,
    weight: 700,
    margin: 30,
    admittedColors: [_consts.BLACKPEARL],
    description: "H1 Website",
    use: ["web"]
  },
  "h2w": {
    size: 25,
    height: 32,
    weight: 700,
    margin: 20,
    admittedColors: [_consts.BLACKPEARL],
    description: "H2 Website",
    use: ["web"]
  },
  "h1.5w": {
    size: 30,
    height: 38,
    weight: 700,
    margin: 20,
    admittedColors: [_consts.BLACKPEARL],
    description: "nomi script retouch e tagging",
    use: ["web"]
  },
  "cardplan-price": {
    size: 35,
    height: 42,
    weight: 600,
    margin: 0,
    admittedColors: [_consts.BLACKPEARL],
    description: "",
    use: ["web"]
  },
  "cardplan-title": {
    size: 20,
    height: 28,
    weight: 700,
    margin: 0,
    admittedColors: [_consts.BLACKPEARL],
    description: "#687fe2",
    use: ["web"]
  },
  "cardplan-values": {
    size: 14,
    height: 21,
    weight: 600,
    margin: 0,
    admittedColors: [_consts.BLACKPEARL],
    description: "",
    use: ["web"]
  },
  "notes": {
    size: 12,
    height: 19,
    weight: 400,
    margin: 0,
    admittedColors: ["#98979e"],
    description: "",
    use: ["web"]
  },
  "prices-table": {
    size: 12,
    height: 19,
    weight: 700,
    margin: 0,
    admittedColors: [_consts.BLACKPEARL],
    description: "#717171",
    use: ["web"]
  },
  "period-date": {
    size: 18,
    height: 25,
    weight: 600,
    margin: 0,
    admittedColors: [_consts.BLACKPEARL],
    description: "#717171",
    use: ["console"]
  },
  "card-title": {
    size: 12,
    height: 19,
    weight: 600,
    margin: 0,
    admittedColors: [_consts.BLACKPEARL],
    description: "#717171",
    use: ["console"]
  },
  "card-blue": {
    size: 12,
    height: 19,
    weight: 500,
    margin: 0,
    admittedColors: [_consts.BLACKPEARL],
    description: "#687fe2",
    use: ["console"]
  },
  "card-right": {
    size: 20,
    height: 28,
    weight: 600,
    margin: 0,
    admittedColors: [_consts.BLACKPEARL],
    description: "",
    use: ["console"]
  },
  "h1c": {
    size: 20,
    height: 28,
    weight: 700,
    margin: 0,
    admittedColors: [_consts.BLACKPEARL, _consts.CHETWODEBLUE],
    description: "",
    use: ["console"]
  },
  "breadcrumb-small": {
    size: 12,
    height: 19,
    weight: 700,
    margin: 0,
    admittedColors: [_consts.BLACKPEARL, _consts.CHETWODEBLUE],
    description: "",
    use: ["console"]
  }
};
exports.TYPOS = TYPOS;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzTypo__Wrapper",
  componentId: "sc-eouo5f-0"
})(["\n  ", "\n"], function (props) {
  return TYPOS[props.variant] ? "\n    color: " + (props.color && TYPOS[props.variant] && TYPOS[props.variant].admittedColors.length > 0 && TYPOS[props.variant].admittedColors.includes(props.color) ? props.color : TYPOS[props.variant] && TYPOS[props.variant].admittedColors.length > 0 && TYPOS[props.variant].admittedColors.length > 0 ? TYPOS[props.variant].admittedColors[0] : _consts.BLACKPEARL) + ";\n    font-size: " + TYPOS[props.variant].size + "px;\n    line-height: " + TYPOS[props.variant].height + "px;\n    font-weight: " + TYPOS[props.variant].weight + ";\n    margin-bottom: " + (props.margin ? TYPOS[props.variant].margin : 0) + "px;\n  " : null;
});

var OzTypo = function OzTypo(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "h1c" : _ref$variant,
      _ref$noMargin = _ref.noMargin,
      noMargin = _ref$noMargin === void 0 ? false : _ref$noMargin,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? null : _ref$color,
      children = _ref.children;
  return __jsx(Wrapper, {
    variant: variant,
    color: color,
    margin: !noMargin
  }, children);
};

var _default = OzTypo;
exports.default = _default;